import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";

const MapZoomIndicator = () => {
  const map = useMap();
  const [zoomLevel, setZoomLevel] = useState(map.getZoom());

  useEffect(() => {
    const handleZoom = () => {
      setZoomLevel(map.getZoom());
    };
    map.on("zoom", handleZoom);
    return () => {
      map.off("zoom", handleZoom);
    };
  }, [map]);

  const getDisplayZoom = (actualZoom: number) => {
    // Gestion du zoom minimum spécifique
    if (actualZoom <= 5.4) return "-1x";

    // Pour les autres zooms, on calcule l'écart par rapport à 6.0
    // Puisqu'on veut que chaque palier de 0.5 représente +1x
    // Formule: (zoom_actuel - zoom_base) / 0.5
    let relativeZoom = Math.round((actualZoom - 6) / 0.5);

    if (relativeZoom < -1) relativeZoom = -1;
    if (relativeZoom > 3) relativeZoom = 3;

    return `${relativeZoom}x`;
  };

  return (
    <div
      className="leaflet-top leaflet-right"
      style={{ zIndex: 1000, pointerEvents: "none" }}
    >
      <div className="leaflet-control bg-white px-2 py-1 m-2 rounded shadow text-sm font-semibold text-gray-700">
        Zoom: {getDisplayZoom(zoomLevel)}
      </div>
    </div>
  );
};

export default MapZoomIndicator;
